import { render, staticRenderFns } from "./SundyPay.vue?vue&type=template&id=7e75a69e&"
import script from "./SundyPay.vue?vue&type=script&lang=js&"
export * from "./SundyPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports